import { createContext, useContext } from 'react'

export const ThemeContext = createContext(null)

/** @returns {{ theme: 'light'|'dark'|'system', resolvedTheme: 'light'|'dark', setTheme: (t: string) => void }} */
export function useTheme() {
  const ctx = useContext(ThemeContext)
  if (!ctx) throw new Error('useTheme must be used inside <ThemeProvider>')
  return ctx
}
